import Joi from "joi";
import UserVehicleOwnership from "../../../../../common/types/user-vehicle-ownership-form";
import formValidationService from "../../../../../common/utils/validation/form-validation.service";
import FormValidationResult from "../../../../../common/utils/validation/types/form-validation-result";
import SignUpDriverFormVehicleData from "../common/types/sign-up-driver-form-vehicle-data";

const validateMake = (
  make: SignUpDriverFormVehicleData["make"]
): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(50).required();

  return formValidationService.validate(make, validationSchema);
};

const validateModel = (
  model: SignUpDriverFormVehicleData["model"]
): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(50).required();

  return formValidationService.validate(model, validationSchema);
};

const validateProductionYear = (
  productionYear: SignUpDriverFormVehicleData["productionYear"]
): FormValidationResult => {
  const validationSchema = Joi.number()
    .min(1971)
    .max(new Date().getFullYear())
    .required();

  return formValidationService.validate(productionYear, validationSchema);
};

const validateNumberOfSeats = (
  numberOfSeats: SignUpDriverFormVehicleData["numberOfSeats"]
): FormValidationResult => {
  const validationSchema = Joi.number().min(2).max(5).required();

  return formValidationService.validate(numberOfSeats, validationSchema);
};

const validateRegistrationNumber = (
  registrationNumber: SignUpDriverFormVehicleData["registrationNumber"]
): FormValidationResult => {
  const registrationPattern = new RegExp(`^[A-Z0-9]*$`);
  const validationSchema = Joi.string()
    .min(4)
    .max(8)
    .pattern(registrationPattern)
    .required();

  return formValidationService.validate(registrationNumber, validationSchema);
};

const validateOwnership = (
  ownershipOption: SignUpDriverFormVehicleData["ownership"]
): FormValidationResult => {
  const validValues = Object.values(UserVehicleOwnership);

  const validationSchema = Joi.string()
    .valid(...validValues)
    .required();

  const ownership = ownershipOption?.value;

  return formValidationService.validate(ownership, validationSchema);
};

const signUpDriverVehicleFormValidationService = {
  validateMake,
  validateModel,
  validateProductionYear,
  validateNumberOfSeats,
  validateRegistrationNumber,
  validateOwnership,
};

export default signUpDriverVehicleFormValidationService;
